// Employer-app reads (SEC-003.1). Each export describes a request for the employerData function;
// the queries live server-side in functions/employerData.js. The signed-in employer comes from the
// login token, so the employerId arguments are kept only for the existing call sites.

export const allJobs = (employerId) => ({ name: 'myJobs' });

export const jobDetails = (jobId) => ({ name: 'jobForEdit', jobId });

export const creditsQuery = (empId) => ({ name: 'credits' });

export const employerInfoQuery = (empId) => ({ name: 'profile' });

export const recordQuery = (jobId) => ({ name: 'record', jobId });

export const historyQuery = { name: 'history' };
